import { Component, OnInit, Input } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {trigger, state, style, animate, transition} from '@angular/animations';

@Component({
  selector: 'app-rotate',
  templateUrl: './rotate.component.html',
  animations: [
    // Each unique animation requires its own trigger. The first argument of the trigger function is the name
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(-90deg)' })),
      state('rotated1', style({ transform: 'rotate(-180deg)' })),
      state('rotated2', style({ transform: 'rotate(-270deg)' })),
      transition('rotated => rotated1', animate('1500ms ease-out')),
      transition('rotated1 => rotated2', animate('1500ms ease-out')),
      transition('rotated2 => default', animate('1500ms ease-out')),
      transition('default => rotated', animate('400ms ease-in'))
  ])
],
  styles: []
})
export class RotateComponent implements OnInit {
  @Input() srcImage = '';
  // tslint:disable-next-line: no-inferrable-types
  state: string = 'default';
  src = '';
  constructor(public router: Router) {
    console.log('hijo constructor: ' + this.srcImage);
  }

  ngOnInit(): void {
    // tslint:disable-next-line: no-string-literal
    console.log('hijo: ' + this.srcImage);
    this.src = this.srcImage;
  }

  rotate() {
    let newState = 'default';
    if (this.state === 'default' ) {
      newState = 'rotated';
    } else if (this.state === 'rotated' ) {
      newState = 'rotated1';
    } else if (this.state === 'rotated1' ) {
      newState = 'rotated2';
    }
    this.state = newState;
  }

}
